// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cIMv","largestCol":"styles_largestCol__rbCem","smallestCol":"styles_smallestCol__7FzmF"};